import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { GetUserResponseData, UpdateUserPayload } from "../types/user"

const putData = async (uuid: string | undefined, payload: UpdateUserPayload) => {
    const { data } = await api.put<GetUserResponseData>(
        `/users/${uuid}`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.USER(uuid))

    return data
}

export const useUpdateUser = (uuid: string | undefined) => {
    return useMutation((payload: UpdateUserPayload) => {
        return putData(uuid, payload)
    })
}
